

import React, { useState,useEffect } from "react";

import "./Enquiry.css"
import Food from "./Food.jsx";
import Logistics from "./Logistics.jsx";
import Logisticssubscribedclients from "../../Clientmanagment/Logistics/Logisticssubscribedclients.js";
import Logisticspaidclients from '../../Clientmanagment/Logistics/Logisticspaidclients.js';
import FoodPaidClents from "../../Clientmanagment/Food/FoodPaidClents.js";
import Foodenquery from "../../Clientmanagment/Food/Foodenquery.js";
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

const Enquiry = () => {
  // Define tabs - Sales Manager specific
  const tabs = [
    { id: 1, name: "Food", component: () => <Foodenquery /> },
    { id: 2, name: "Logistics", component: () => <Logisticssubscribedclients /> },

  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  // Function to switch tabs - this will be passed to child components
  useEffect(() => {
         const handleTabChange = (event) => {
             const tabId = event.detail?.tabId;
             
             if (tabId) {
                 // Find tab by name (case insensitive)
                 const tab = tabs.find(t => 
                     t.name.toLowerCase() === tabId.toLowerCase() || 
                     t.id === tabId
                 );
                 
                 if (tab) {
                     setActiveTab(tab.id);
                 } else {
                     console.warn("⚠️ Tab not found:", tabId);
                 }
             }
         };
 
         window.addEventListener('changeTab', handleTabChange);
         return () => window.removeEventListener('changeTab', handleTabChange);
     }, [tabs]);

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="sales-manager-container">
      {/* Tabs */}
      <div className="sm-tabs-wrapper">
        <div className="sm-tabs-scroll">
          <div className="sm-tabs-row">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`sm-tab-btn ${activeTab === tab.id ? "sm-tab-active" : ""
                  }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Active Component - Pass switchTab function as prop */}
      <div className="sm-tab-content">
         {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Enquiry;